import * as THREE from "three";

import Debug from "./Utils/Debug.js";
import Sizes from "./Utils/Sizes.js";
import Time from "./Utils/Time.js";
import Camera from "./Camera.js";
import Renderer from "./Renderer.js";
import World from "./World/World.js";
import Resources from "./Utils/Resources.js";

import settings from "./settings.js";
import ModelGroup from "./World/ModelGroup.js";
import RayCaster from "./RayCaster.js";
import Overlay from "./Overlay.js";
import PostProcessing from "./PostProcessing.js";

let instance = null;

export default class Experience {
  constructor(_canvas) {
    // Singleton
    if (instance) {
      return instance;
    }
    instance = this;

    // Global access
    window.experience = this;

    // Options
    this.canvas = _canvas;

    // Setup
    this.debug = new Debug();
    this.sizes = new Sizes();
    this.time = new Time();
    this.scene = new THREE.Scene();
    this.group = new ModelGroup();
    this.resources = new Resources(settings.sources);
    this.camera = new Camera();
    this.renderer = new Renderer();
    this.raycaster = new RayCaster();
    this.overlay = new Overlay();

    this.world = new World();
    if (settings.postProcessing) {
      this.postProcessing = new PostProcessing();
    }

    // Resize event
    this.sizes.on("resize", () => {
      this.resize();
    });

    this.sizes.on("scroll", () => {
      this.scroll();
    });

    // Time tick event
    this.time.on("tick", () => {
      this.update();
    });
  }

  resize() {
    this.camera.resize();
    this.renderer.resize();

    if (this.postProcessing) {
      this.postProcessing.resize();
    }
  }
  scroll() {
    this.camera.scroll();
    this.world.environment?.scroll();
  }
  update() {
    this.camera.update();
    this.world.update();
    this.raycaster.update();

    // The composer's final pass draws to screen, so rendering the scene
    // directly as well would just be overwritten
    if (this.postProcessing) {
      this.postProcessing.update();
    } else {
      this.renderer.update();
    }
  }

  destroy() {
    this.sizes.off("resize");
    this.sizes.off("scroll");
    this.time.off("tick");

    // Traverse the whole scene
    this.scene.traverse((child) => {
      // Test if it's a mesh
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();

        // Loop through the material properties
        for (const key in child.material) {
          const value = child.material[key];

          // Test if there is a dispose function
          if (value && typeof value.dispose === "function") {
            value.dispose();
          }
        }
      }
    });

    this.renderer.instance.dispose();

    if (this.debug.active) this.debug.ui.destroy();
  }
}
